/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phaseintake1Inputs */

const en_phaseintake1 = /** @type {(inputs: Phaseintake1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intake`)
};

const pt_phaseintake1 = /** @type {(inputs: Phaseintake1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recolha`)
};

/**
* | output |
* | --- |
* | "Intake" |
*
* @param {Phaseintake1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const phaseintake1 = /** @type {((inputs?: Phaseintake1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phaseintake1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phaseintake1(inputs)
	return pt_phaseintake1(inputs)
});
export { phaseintake1 as "phaseIntake" }